<template>
  <div>
    <AppNewHeader
      :userName="userName"
      style="width: 100%"
      :placeholderText="'搜索知识资源'"
    />
    <div class="dljg_banner">
      <h1>
        <img :src="dljg" alt="" />
      </h1>
    </div>
    <div class="wrap">
      <div class="branch-office">
        <h5 class="module-title">
          <b>合作资源意向咨询</b>
          <span
            >（如您单位知识库需要在平台上运营，可联系以下销售经理进行咨询）</span
          >
        </h5>
        <div class="agentList">
          <div
            class="agentItem"
            v-for="(item, index) in dataInfoList"
            :key="index"
          >
            <div class="agenUserInfo">
              <div class="agen_left">
                <div class="agen_text">
                  <h3>负责区域</h3>
                  <p>{{ item.region }}</p>
                </div>
              </div>
              <div class="agen_right">
                <div class="avaterCover">
                  <img :src="item.avater" alt="" />
                </div>
                <div class="agenName">{{ item.name }}</div>
              </div>
            </div>
            <div class="userInfoList">
              <div class="email">
                <div class="emailIcon">
                  <img :src="emailImg" alt="" />
                </div>
                <div class="emailCode">
                  <p class="emailName">邮箱</p>
                  <p class="emaileCodes">{{ item.email }}</p>
                </div>
              </div>
              <div class="email">
                <div class="emailIcon">
                  <img :src="phoneImg" alt="" />
                </div>
                <div class="emailCode">
                  <p class="emailName">电话</p>
                  <p class="emaileCodes">{{ item.phone }}</p>
                </div>
              </div>
              <div class="email">
                <div class="emailIcon">
                  <img :src="adrressImg" alt="" />
                </div>
                <div class="emailCode">
                  <p class="emailName">地址</p>
                  <p class="emaileCodes">{{ item.address }}</p>
                </div>
              </div>
              <!-- <div class="email">
                <div class="emailIcon">
                  <img :src="gwImg" alt="" />
                </div>
                <div class="emailCode">
                  <p class="emailName">官网</p>
                  <p class="emaileCodes">{{ item.official }}</p>
                </div>
              </div> -->

              <div class="QRCodeItem">
                <div class="QRcode">
                  <img :src="item.QRcode" alt="" />
                  <p>扫码添加微信</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-footer>
      <div>
        <AppFooter />
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import dljg from "@/assets/image/agencytitle.png";
import zjmimg from "@/assets/headerimage/zjmimg.png";
import cxyimg from "@/assets/headerimage/cxyimg.png";
import wycimg from "@/assets/headerimage/wycimg.png";
import emailImg from "@/assets/headerimage/email.png";
import phoneImg from "@/assets/headerimage/phone.png";
import adrressImg from "@/assets/headerimage/adrress.png";
import gwImg from "@/assets/headerimage/gw.png";
import qrcode01 from "@/assets/headerimage/QRzjm.png";
import qrcode02 from "@/assets/headerimage/QRcxy.png";
import qrcode03 from "@/assets/headerimage/QRwyc.png";
import { ref, onMounted, onUnmounted } from "vue";
import { Cookie } from "@/utils/Cookie";
import { getBuyLog } from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";
const weburl = ref(window.location.href);
const { stayTime, totalStayTimes } = usePageStayTime();
const dataInfoList = ref([
  {
    name: "祝家萌",
    region: "北京 吉林 辽宁 河北 广西 湖南 河南 贵州 云南 上海 浙江 四川 广东 重庆 黑龙江",
    avater: zjmimg,
    email: "1220693269@qq.com",
    phone: "17392256904",
    address: "陕西省西安市雁塔区锦业路10号中投国际B座1507",
    official: "http://www.ckbop.com",
    QRcode: qrcode01,
  },
  // {
  //   // name: "崔欣雨",
  //   name: "祝家萌",
  //   region: "北京 ",
  //   // avater: cxyimg,
  //   avater: zjmimg,
  //   // email: "1550636709@qq.com",
  //   // phone: "19909389407",
  //   email: "1220693269@qq.com",
  //   phone: "17392256904",
  //   address: "陕西省西安市雁塔区锦业路10号中投国际B座1507",
  //   official: "http://www.ckbop.com",
  //   // QRcode: qrcode02,
  //   QRcode: qrcode01,
  // },
  {
    name: "王英驰",
    region: "北京 江苏 江西 西藏 海南 山西 福建 新疆 安徽 山东  甘肃 青海 天津 湖北 宁夏 内蒙古",
    avater: wycimg,
    email: "wangyingchi2001@168.com",
    phone: "18592036215",
    address: "陕西省西安市雁塔区锦业路10号中投国际B座1507",
    official: "http://www.ckbop.com",
    QRcode: qrcode03,
  },
]);
const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};

const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "5",
      url: weburl.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "5",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
onMounted(async () => {
  checkTokenStatus();
});
onUnmounted(async () => {
  await handleLog();
});
</script>
<style scoped>
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.dljg_banner {
  background: url(../../assets/newimages/dlijg2.png) no-repeat top center #3040d1;
  height: 200px;
  background-size: cover;
}
.dljg_banner h1 {
  font-size: 38px;
  font-weight: bold;
  line-height: 40px;
  color: #fdfdfd;
  letter-spacing: 4px;
  text-align: center;
  align-items: center;
  padding-top: 66px;
  padding-right: 507px;
}

.dljg_banner h1 img {
  width: 342px;
  height: 59px;
}
.wrap {
  width: 1400px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.branch-office {
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.module-title {
  padding-top: 15px;
  /* padding-left: 10px; */
  margin-bottom: 15px;
  line-height: 60px;
}
.module-title b {
  display: inline-block;
  vertical-align: middle;
  font-size: 30px;
  font-weight: bold;
  color: #333;
  border-radius: 5px;
}
.module-title span {
  float: right;
  font-size: 16px;
  font-weight: normal;
  color: #666;
}

.clearfix {
  clear: both;
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  font-size: 0;
  visibility: hidden;
  line-height: 0;
}

.agentList {
  width: 100%;
  height: 680px;
  display: flex;
  /* justify-content: space-between; */
}
.agentItem {
  width: 450px;
  height: 600px;
  background-image: url(@/assets/image/agency.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 20px;
}
.agentItem:last-child{
  margin-left: 50px;
}
.agenUserInfo {
  height: 188px;
  display: flex;
  justify-content: space-between;
}
.agen_text h3 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
  line-height: 33px;
  text-align: justify;
  font-style: normal;
}
.agen_text p {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(225, 225, 225, 0.8);
  line-height: 30px;
  text-align: justify;
  font-style: normal;
  padding-top: 16px;
  width: 275px;
  word-spacing: 13px;
}
.avaterCover {
  width: 80px;
  height: 80px;
}
.avaterCover img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.agen_right {
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avaterCover {
  width: 80px;
  height: 80px;
}

.avaterCover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.agenName {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  text-align: justify;
  font-style: normal;
  padding-top: 8px;
}
.userInfoList {
  height: 454px;
}
.email {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
}
.emailIcon {
  width: 48px;
  height: 48px;
}
.emailIcon img {
  width: 100%;
  height: 100%;
}
.emailCode {
  margin-left: 16px;
}
.emailName {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
}
.emaileCodes {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: justify;
  font-style: normal;
}
.QRcode {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}
.QRcode img {
  width: 106px;
  height: 106px;
}
.QRcode p {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  font-style: normal;
}
.QRCodeItem {
  display: flex;
  justify-content: right;
  margin-top: 19px;
}
</style>
